import {appFetch, AppFetchResponse} from "../utils/appFetch";

export const getTemplates = async (selectedDomain: string): Promise<AppFetchResponse> => {
    return appFetch({
        endpoint: `messages-templates?domain=${selectedDomain}`,
        method: 'GET',
        headers: {
            "Content-Type": "application/json",
        },
        domain: selectedDomain,
        isEncrypted: true,
    });
}